<div class="relative" [style.height.px]="inputHeight">
  @if (overlayHtml$ | async; as overlayHtml) {
    <div
      class="absolute top-0 left-0 w-full h-full pointer-events-none z-10 text-overlay"
      [innerHTML]="overlayHtml"
    ></div>
  }

  <anecdotes-comment-input
    #textInput
    class="text-input group w-full h-full outline-none bg-transparent comment"
    [editable]="editable"
    [placeholder]="placeholder"
    [formControl]="textControl"
    [usersMap]="usersMap"
    [stickyOptions]="stickyOptions"
    [dropdownWidth]="dropdownWidth"
    (linkClick)="linkClick($event)"
    (focusin)="focusIn()"
    (focusout)="focusOut()"
  >
    <ng-template #optionTemplate let-user="user" let-isFocused="isFocused">
      <app-dropdown-option [selected]="isFocused">
        <app-commenting-user-logo [userId]="user.id" [fallbackUserName]="user.name"></app-commenting-user-logo>
        <span
          class="truncate max-w-full block"
          [ngbTooltip]="user['displayName'] || user.name"
          [openTooltipWhenOverflowedAndHovered]="true"
          [openOnWidthOverflow]="true"
          [placement]="'top'"
        >
          {{ user['displayName'] || user.name }}
        </span>
      </app-dropdown-option>
    </ng-template>
  </anecdotes-comment-input>
</div>
